<template>
  	<AddBillingAccount />
</template>

<script>

// @ is an alias to /src
import AddBillingAccount from "@/components/AddBillingAccount.vue";

export default {
  name: "AddBillingAccounts",
  components: {
    AddBillingAccount,
  },
};
</script>
